import {memoize} from 'lodash';
import colorList from './colorList.json';

let nextColor = 0;
export const getOptionColor = memoize(optionId => colorList[nextColor++ % colorList.length]);
